module.exports = __webpack_public_path__ + "img/escudo-h.7028b01c.png";